// extracted by mini-css-extract-plugin
module.exports = {"notification":"NotificationIcon_notification__1-tSt","user-profile-icon":"NotificationIcon_user-profile-icon__2eGzC","badge":"NotificationIcon_badge__4zZZh"};